import { render, staticRenderFns } from "./MessageProcess.vue?vue&type=template&id=7fbc2f38&scoped=true"
import script from "./MessageProcess.vue?vue&type=script&lang=js"
export * from "./MessageProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc2f38",
  null
  
)

export default component.exports